import './Show.svelte.css.proxy.js';
/* src/components/Show.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_block,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	safe_not_equal,
	set_data,
	space,
	text,
	transition_in,
	transition_out,
	update_keyed_each
} from "../_snowpack/pkg/svelte/internal.js";

import ChevronDownSmall from "./Icon/ChevronDownSmall.svelte.js";
import ChevronUpSmall from "./Icon/ChevronUpSmall.svelte.js";
import Episode from "./Episode.svelte.js";
import { byEarliestDate, latestEpisode, notYetReleased } from "./utils.js";
import Localized from "./Lang/Localized.svelte.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[8] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[11] = list[i];
	return child_ctx;
}

// (73:8) {#if show.joint_groups.length > 0}
function create_if_block_4(ctx) {
	let localized;
	let current;

	localized = new Localized({
			props: {
				key: "UNIT_JOINT_WITH",
				class: "hidden sm:block mt-1 text-xs italic text-gray-400 dark:text-gray-300",
				$$slots: { "0": [create__0_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(localized.$$.fragment);
		},
		l(nodes) {
			claim_component(localized.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(localized, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const localized_changes = {};

			if (dirty & /*$$scope, show*/ 16385) {
				localized_changes.$$scope = { dirty, ctx };
			}

			localized.$set(localized_changes);
		},
		i(local) {
			if (current) return;
			transition_in(localized.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(localized.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(localized, detaching);
		}
	};
}

// (79:20) {#each show.joint_groups as group (group.id)}
function create_each_block_1(key_1, ctx) {
	let span;
	let t0_value = /*group*/ ctx[11].name + "";
	let t0;
	let t1;

	return {
		key: key_1,
		first: null,
		c() {
			span = element("span");
			t0 = text(t0_value);
			t1 = space();
			this.h();
		},
		l(nodes) {
			span = claim_element(nodes, "SPAN", {});
			var span_nodes = children(span);
			t0 = claim_text(span_nodes, t0_value);
			t1 = claim_space(span_nodes);
			span_nodes.forEach(detach);
			this.h();
		},
		h() {
			this.first = span;
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t0);
			append(span, t1);
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			if (dirty & /*show*/ 1 && t0_value !== (t0_value = /*group*/ ctx[11].name + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (78:16) <span slot="0">
function create__0_slot(ctx) {
	let span;
	let each_blocks = [];
	let each_1_lookup = new Map();
	let each_value_1 = /*show*/ ctx[0].joint_groups;
	const get_key = ctx => /*group*/ ctx[11].id;

	for (let i = 0; i < each_value_1.length; i += 1) {
		let child_ctx = get_each_context_1(ctx, each_value_1, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block_1(key, child_ctx));
	}

	return {
		c() {
			span = element("span");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			this.h();
		},
		l(nodes) {
			span = claim_element(nodes, "SPAN", { slot: true });
			var span_nodes = children(span);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(span_nodes);
			}

			span_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span, "slot", "0");
		},
		m(target, anchor) {
			insert(target, span, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(span, null);
			}
		},
		p(ctx, dirty) {
			if (dirty & /*show*/ 1) {
				each_value_1 = /*show*/ ctx[0].joint_groups;
				each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value_1, each_1_lookup, span, destroy_block, create_each_block_1, null, get_each_context_1);
			}
		},
		d(detaching) {
			if (detaching) detach(span);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d();
			}
		}
	};
}

// (114:8) {:else}
function create_else_block_1(ctx) {
	let episode;
	let t;
	let if_block_anchor;
	let current;

	episode = new Episode({
			props: {
				episode: /*latest*/ ctx[4],
				status: /*show*/ ctx[0].status,
				latest: true
			}
		});

	let if_block = /*unfinishedEpisodes*/ ctx[2].length > 1 && create_if_block_2(ctx);

	return {
		c() {
			create_component(episode.$$.fragment);
			t = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			claim_component(episode.$$.fragment, nodes);
			t = claim_space(nodes);
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			mount_component(episode, target, anchor);
			insert(target, t, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const episode_changes = {};
			if (dirty & /*latest*/ 16) episode_changes.episode = /*latest*/ ctx[4];
			if (dirty & /*show*/ 1) episode_changes.status = /*show*/ ctx[0].status;
			episode.$set(episode_changes);

			if (/*unfinishedEpisodes*/ ctx[2].length > 1) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*unfinishedEpisodes*/ 4) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block_2(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(episode.$$.fragment, local);
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(episode.$$.fragment, local);
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			destroy_component(episode, detaching);
			if (detaching) detach(t);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (87:8) {#if expanded}
function create_if_block(ctx) {
	let div0;
	let t0;
	let button;
	let div1;
	let chevronupsmall;
	let t1;
	let current_block_type_index;
	let if_block;
	let current;
	let mounted;
	let dispose;
	let each_value = /*unfinishedEpisodes*/ ctx[2].slice(0, 4);
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	chevronupsmall = new ChevronUpSmall({});
	const if_block_creators = [create_if_block_1, create_else_block];
	const if_blocks = [];

	function select_block_type_1(ctx, dirty) {
		if (/*moreNumber*/ ctx[5] === 1) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_1(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			div0 = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t0 = space();
			button = element("button");
			div1 = element("div");
			create_component(chevronupsmall.$$.fragment);
			t1 = space();
			if_block.c();
			this.h();
		},
		l(nodes) {
			div0 = claim_element(nodes, "DIV", { class: true });
			var div0_nodes = children(div0);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(div0_nodes);
			}

			div0_nodes.forEach(detach);
			t0 = claim_space(nodes);
			button = claim_element(nodes, "BUTTON", { class: true });
			var button_nodes = children(button);
			div1 = claim_element(button_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			claim_component(chevronupsmall.$$.fragment, div1_nodes);
			div1_nodes.forEach(detach);
			t1 = claim_space(button_nodes);
			if_block.l(button_nodes);
			button_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div0, "class", "grid grid-cols-2 justify-between");
			attr(div1, "class", "h-5 w-5");
			attr(button, "class", "flex flex-row mt-2 text-gray-500 hover:text-gray-400 dark:text-gray-200 transition-colors");
		},
		m(target, anchor) {
			insert(target, div0, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div0, null);
			}

			insert(target, t0, anchor);
			insert(target, button, anchor);
			append(button, div1);
			mount_component(chevronupsmall, div1, null);
			append(button, t1);
			if_blocks[current_block_type_index].m(button, null);
			current = true;

			if (!mounted) {
				dispose = listen(button, "click", /*toggleExpand*/ ctx[7]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*unfinishedEpisodes, show, latest*/ 21) {
				each_value = /*unfinishedEpisodes*/ ctx[2].slice(0, 4);
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(div0, null);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}

			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_1(ctx, dirty);

			if (current_block_type_index !== previous_block_index) {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					
				}

				transition_in(if_block, 1);
				if_block.m(button, null);
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			transition_in(chevronupsmall.$$.fragment, local);
			transition_in(if_block);
			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			transition_out(chevronupsmall.$$.fragment, local);
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div0);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(t0);
			if (detaching) detach(button);
			destroy_component(chevronupsmall);
			if_blocks[current_block_type_index].d();
			mounted = false;
			dispose();
		}
	};
}

// (116:12) {#if unfinishedEpisodes.length > 1}
function create_if_block_2(ctx) {
	let button;
	let div;
	let chevrondownsmall;
	let t;
	let current_block_type_index;
	let if_block;
	let current;
	let mounted;
	let dispose;
	chevrondownsmall = new ChevronDownSmall({});
	const if_block_creators = [create_if_block_3, create_else_block_2];
	const if_blocks = [];

	function select_block_type_2(ctx, dirty) {
		if (/*moreNumber*/ ctx[5] === 1) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_2(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			button = element("button");
			div = element("div");
			create_component(chevrondownsmall.$$.fragment);
			t = space();
			if_block.c();
			this.h();
		},
		l(nodes) {
			button = claim_element(nodes, "BUTTON", { class: true });
			var button_nodes = children(button);
			div = claim_element(button_nodes, "DIV", { class: true });
			var div_nodes = children(div);
			claim_component(chevrondownsmall.$$.fragment, div_nodes);
			div_nodes.forEach(detach);
			t = claim_space(button_nodes);
			if_block.l(button_nodes);
			button_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "h-5 w-5");
			attr(button, "class", "flex flex-row mt-2 text-blue-500 hover:text-blue-400 dark:text-blue-300 transition-colors");
		},
		m(target, anchor) {
			insert(target, button, anchor);
			append(button, div);
			mount_component(chevrondownsmall, div, null);
			append(button, t);
			if_blocks[current_block_type_index].m(button, null);
			current = true;

			if (!mounted) {
				dispose = listen(button, "click", /*toggleExpand*/ ctx[7]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_2(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(button, null);
			}
		},
		i(local) {
			if (current) return;
			transition_in(chevrondownsmall.$$.fragment, local);
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(chevrondownsmall.$$.fragment, local);
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(button);
			destroy_component(chevrondownsmall);
			if_blocks[current_block_type_index].d();
			mounted = false;
			dispose();
		}
	};
}

// (128:20) {:else}
function create_else_block_2(ctx) {
	let localized;
	let current;

	localized = new Localized({
			props: {
				key: "UNIT_SHOW_REMAINDER_PLURAL",
				$$slots: { "1": [create__1_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(localized.$$.fragment);
		},
		l(nodes) {
			claim_component(localized.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(localized, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const localized_changes = {};

			if (dirty & /*$$scope, moreNumber*/ 16416) {
				localized_changes.$$scope = { dirty, ctx };
			}

			localized.$set(localized_changes);
		},
		i(local) {
			if (current) return;
			transition_in(localized.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(localized.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(localized, detaching);
		}
	};
}

// (124:20) {#if moreNumber === 1}
function create_if_block_3(ctx) {
	let localized;
	let current;

	localized = new Localized({
			props: {
				key: "UNIT_SHOW_REMAINDER_SINGULAR",
				$$slots: { "1": [create__1_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(localized.$$.fragment);
		},
		l(nodes) {
			claim_component(localized.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(localized, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const localized_changes = {};

			if (dirty & /*$$scope, moreNumber*/ 16416) {
				localized_changes.$$scope = { dirty, ctx };
			}

			localized.$set(localized_changes);
		},
		i(local) {
			if (current) return;
			transition_in(localized.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(localized.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(localized, detaching);
		}
	};
}

// (130:28) <span slot="1">
function create__1_slot_1(ctx) {
	let span;
	let t;

	return {
		c() {
			span = element("span");
			t = text(/*moreNumber*/ ctx[5]);
			this.h();
		},
		l(nodes) {
			span = claim_element(nodes, "SPAN", { slot: true });
			var span_nodes = children(span);
			t = claim_text(span_nodes, /*moreNumber*/ ctx[5]);
			span_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span, "slot", "1");
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty & /*moreNumber*/ 32) set_data(t, /*moreNumber*/ ctx[5]);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (126:28) <span slot="1">
function create__1_slot(ctx) {
	let span;
	let t;

	return {
		c() {
			span = element("span");
			t = text(/*moreNumber*/ ctx[5]);
			this.h();
		},
		l(nodes) {
			span = claim_element(nodes, "SPAN", { slot: true });
			var span_nodes = children(span);
			t = claim_text(span_nodes, /*moreNumber*/ ctx[5]);
			span_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span, "slot", "1");
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty & /*moreNumber*/ 32) set_data(t, /*moreNumber*/ ctx[5]);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (89:16) {#each unfinishedEpisodes.slice(0, 4) as episode}
function create_each_block(ctx) {
	let episode;
	let current;

	episode = new Episode({
			props: {
				episode: /*episode*/ ctx[8],
				status: /*show*/ ctx[0].status,
				latest: /*episode*/ ctx[8].id === /*latest*/ ctx[4].id,
				inList: true
			}
		});

	return {
		c() {
			create_component(episode.$$.fragment);
		},
		l(nodes) {
			claim_component(episode.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(episode, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const episode_changes = {};
			if (dirty & /*unfinishedEpisodes*/ 4) episode_changes.episode = /*episode*/ ctx[8];
			if (dirty & /*show*/ 1) episode_changes.status = /*show*/ ctx[0].status;
			if (dirty & /*unfinishedEpisodes, latest*/ 20) episode_changes.latest = /*episode*/ ctx[8].id === /*latest*/ ctx[4].id;
			episode.$set(episode_changes);
		},
		i(local) {
			if (current) return;
			transition_in(episode.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(episode.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(episode, detaching);
		}
	};
}

// (107:16) {:else}
function create_else_block(ctx) {
	let localized;
	let current;

	localized = new Localized({
			props: {
				key: "UNIT_SHOW_LESS_PLURAL",
				fallbackKey: "UNIT_SHOW_LESS"
			}
		});

	return {
		c() {
			create_component(localized.$$.fragment);
		},
		l(nodes) {
			claim_component(localized.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(localized, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(localized.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(localized.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(localized, detaching);
		}
	};
}

// (105:16) {#if moreNumber === 1}
function create_if_block_1(ctx) {
	let localized;
	let current;
	localized = new Localized({ props: { key: "UNIT_SHOW_LESS" } });

	return {
		c() {
			create_component(localized.$$.fragment);
		},
		l(nodes) {
			claim_component(localized.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(localized, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(localized.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(localized.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(localized, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div8;
	let div6;
	let img;
	let img_src_value;
	let img_alt_value;
	let t0;
	let div0;
	let t1;
	let div1;
	let t2;
	let div2;
	let t3;
	let div3;
	let t4;
	let div4;
	let t5;
	let div5;
	let t6;
	let div7;
	let h1;
	let t7_value = /*show*/ ctx[0].name + "";
	let t7;
	let t8;
	let t9;
	let current_block_type_index;
	let if_block1;
	let div8_class_value;
	let current;
	let if_block0 = /*show*/ ctx[0].joint_groups.length > 0 && create_if_block_4(ctx);
	const if_block_creators = [create_if_block, create_else_block_1];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*expanded*/ ctx[3]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			div8 = element("div");
			div6 = element("div");
			img = element("img");
			t0 = space();
			div0 = element("div");
			t1 = space();
			div1 = element("div");
			t2 = space();
			div2 = element("div");
			t3 = space();
			div3 = element("div");
			t4 = space();
			div4 = element("div");
			t5 = space();
			div5 = element("div");
			t6 = space();
			div7 = element("div");
			h1 = element("h1");
			t7 = text(t7_value);
			t8 = space();
			if (if_block0) if_block0.c();
			t9 = space();
			if_block1.c();
			this.h();
		},
		l(nodes) {
			div8 = claim_element(nodes, "DIV", { class: true });
			var div8_nodes = children(div8);
			div6 = claim_element(div8_nodes, "DIV", { class: true });
			var div6_nodes = children(div6);
			img = claim_element(div6_nodes, "IMG", { class: true, src: true, alt: true });
			t0 = claim_space(div6_nodes);
			div0 = claim_element(div6_nodes, "DIV", { class: true });
			children(div0).forEach(detach);
			t1 = claim_space(div6_nodes);
			div1 = claim_element(div6_nodes, "DIV", { class: true });
			children(div1).forEach(detach);
			t2 = claim_space(div6_nodes);
			div2 = claim_element(div6_nodes, "DIV", { class: true });
			children(div2).forEach(detach);
			t3 = claim_space(div6_nodes);
			div3 = claim_element(div6_nodes, "DIV", { class: true });
			children(div3).forEach(detach);
			t4 = claim_space(div6_nodes);
			div4 = claim_element(div6_nodes, "DIV", { class: true });
			children(div4).forEach(detach);
			t5 = claim_space(div6_nodes);
			div5 = claim_element(div6_nodes, "DIV", { class: true });
			children(div5).forEach(detach);
			div6_nodes.forEach(detach);
			t6 = claim_space(div8_nodes);
			div7 = claim_element(div8_nodes, "DIV", { class: true });
			var div7_nodes = children(div7);
			h1 = claim_element(div7_nodes, "H1", { class: true });
			var h1_nodes = children(h1);
			t7 = claim_text(h1_nodes, t7_value);
			h1_nodes.forEach(detach);
			t8 = claim_space(div7_nodes);
			if (if_block0) if_block0.l(div7_nodes);
			t9 = claim_space(div7_nodes);
			if_block1.l(div7_nodes);
			div7_nodes.forEach(detach);
			div8_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(img, "class", "z-0 rounded-md");
			if (img.src !== (img_src_value = /*show*/ ctx[0].poster)) attr(img, "src", img_src_value);
			attr(img, "alt", img_alt_value = "Poster for " + /*show*/ ctx[0].name);
			attr(div0, "class", "z-10 rounded-md absolute inset-0 shadow-inner");
			attr(div1, "class", "z-10 rounded-md absolute inset-0 shadow-inner");
			attr(div2, "class", "z-10 rounded-md absolute inset-0 shadow-inner");
			attr(div3, "class", "z-10 rounded-md absolute inset-0 shadow-inner");
			attr(div4, "class", "z-10 rounded-md absolute inset-0 shadow-inner");
			attr(div5, "class", "app-poster-overlay z-20 rounded-md absolute inset-0 bg-black opacity-5 transition-opacity svelte-1ko5w15");
			attr(div6, "class", "hidden sm:block w-24 mt-3 ml-3 mb-8 relative flex-none");
			attr(h1, "class", "font-medium text-base text-gray-800 dark:text-gray-100");
			attr(div7, "class", "text-xs h-full flex-grow px-3 pt-2 py-8 max-w-full flex flex-col");
			attr(div8, "class", div8_class_value = "app-show shadow-md rounded-md overflow-hidden flex flex-row items-start relative bg-white dark:bg-gray-700 " + /*accentOptions*/ ctx[6][/*accent*/ ctx[1]] + " svelte-1ko5w15");
		},
		m(target, anchor) {
			insert(target, div8, anchor);
			append(div8, div6);
			append(div6, img);
			append(div6, t0);
			append(div6, div0);
			append(div6, t1);
			append(div6, div1);
			append(div6, t2);
			append(div6, div2);
			append(div6, t3);
			append(div6, div3);
			append(div6, t4);
			append(div6, div4);
			append(div6, t5);
			append(div6, div5);
			append(div8, t6);
			append(div8, div7);
			append(div7, h1);
			append(h1, t7);
			append(div7, t8);
			if (if_block0) if_block0.m(div7, null);
			append(div7, t9);
			if_blocks[current_block_type_index].m(div7, null);
			current = true;
		},
		p(ctx, [dirty]) {
			if (!current || dirty & /*show*/ 1 && img.src !== (img_src_value = /*show*/ ctx[0].poster)) {
				attr(img, "src", img_src_value);
			}

			if (!current || dirty & /*show*/ 1 && img_alt_value !== (img_alt_value = "Poster for " + /*show*/ ctx[0].name)) {
				attr(img, "alt", img_alt_value);
			}

			if ((!current || dirty & /*show*/ 1) && t7_value !== (t7_value = /*show*/ ctx[0].name + "")) set_data(t7, t7_value);

			if (/*show*/ ctx[0].joint_groups.length > 0) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty & /*show*/ 1) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_4(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(div7, t9);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block1 = if_blocks[current_block_type_index];

				if (!if_block1) {
					if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block1.c();
				} else {
					if_block1.p(ctx, dirty);
				}

				transition_in(if_block1, 1);
				if_block1.m(div7, null);
			}

			if (!current || dirty & /*accent*/ 2 && div8_class_value !== (div8_class_value = "app-show shadow-md rounded-md overflow-hidden flex flex-row items-start relative bg-white dark:bg-gray-700 " + /*accentOptions*/ ctx[6][/*accent*/ ctx[1]] + " svelte-1ko5w15")) {
				attr(div8, "class", div8_class_value);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div8);
			if (if_block0) if_block0.d();
			if_blocks[current_block_type_index].d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let unfinishedEpisodes;
	let latest;
	let moreNumber;

	const accentOptions = {
		red: "rounded-t-none border-t-2 border-red-500 dark:border-red-400",
		yellow: "rounded-t-none border-t-2 border-yellow-500 dark:border-yellow-400",
		green: "rounded-t-none border-t-2 border-green-500 dark:border-green-400",
		blue: "rounded-t-none border-t-2 border-blue-500 dark:border-blue-400",
		indigo: "rounded-t-none border-t-2 border-indigo-500 dark:border-indigo-400",
		purple: "rounded-t-none border-t-2 border-purple-500 dark:border-purple-400",
		pink: "rounded-t-none border-t-2 border-pink-500 dark:border-pink-400",
		none: "border-none"
	};

	let { show } = $$props;
	let { accent = "green" } = $$props;
	let expanded = false;

	function toggleExpand() {
		if (unfinishedEpisodes.length > 1) {
			$$invalidate(3, expanded = !expanded);
		} else {
			$$invalidate(3, expanded = false);
		}
	}

	$$self.$$set = $$props => {
		if ("show" in $$props) $$invalidate(0, show = $$props.show);
		if ("accent" in $$props) $$invalidate(1, accent = $$props.accent);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*show*/ 1) {
			$: $$invalidate(2, unfinishedEpisodes = show
			? show.episodes.filter(notYetReleased).sort(byEarliestDate("air_date"))
			: []);
		}

		if ($$self.$$.dirty & /*show*/ 1) {
			$: $$invalidate(4, latest = latestEpisode(show));
		}

		if ($$self.$$.dirty & /*unfinishedEpisodes*/ 4) {
			$: $$invalidate(5, moreNumber = Math.min(unfinishedEpisodes.length - 1, 3));
		}
	};

	return [
		show,
		accent,
		unfinishedEpisodes,
		expanded,
		latest,
		moreNumber,
		accentOptions,
		toggleExpand
	];
}

class Show extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { show: 0, accent: 1 });
	}
}

export default Show;
//# sourceMappingURL=Show.svelte.js.map
